import React, { ReactNode } from "react";

import Headline from "../../base/atoms/Headline";
import LoadingIndicator from "../LoadingIndicator";
import Button from "../NewForms/Button";
import { UncontrolledNotification as Notification } from "../Notification";

interface FormNotificationsProps {
    sendingError: boolean;
    sending: boolean;
    emailSent: boolean;
    onRetry: () => void;
    errorHeadline?: string;
    errorText?: string;
    retryLabel?: string;
    loadingText?: string;
    successHeadline?: string;
    successText?: string;
    /** The form itself, rendered when none of the three states apply. */
    children: ReactNode;
}

const FormNotifications = ({
    sendingError,
    sending,
    emailSent,
    onRetry,
    errorHeadline = "Entschuldigung",
    errorText = "Es ist leider ein Fehler aufgetreten. Versuche es bitte erneut.",
    retryLabel = "Zum Formular",
    loadingText = "Deine Nachricht wird übermittelt. Habe bitte einen Moment Geduld.",
    successHeadline = "Vielen Dank für Deine Anfrage",
    successText = "Wir haben Deine Anfrage erhalten und melden uns in Kürze bei Dir.",
    children,
}: FormNotificationsProps) => {
    if (sendingError) {
        return (
            <Notification>
                <Headline>{errorHeadline}</Headline>
                <div>{errorText}</div>
                <Button onClick={onRetry} fullWidth>
                    {retryLabel}
                </Button>
            </Notification>
        );
    }

    if (sending) {
        return (
            <Notification>
                <LoadingIndicator>{loadingText}</LoadingIndicator>
            </Notification>
        );
    }

    if (emailSent) {
        return (
            <Notification>
                <Headline>{successHeadline}</Headline>
                <div>{successText}</div>
            </Notification>
        );
    }

    return <>{children}</>;
};

export default FormNotifications;
